import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const ItemContainer = styled.div`
  padding: 10px 20px;
  line-height: 1.5;
`;
